import * as actions from '~/actions/team';

const defaultState = {
  teams: [],
};

/*
 * Reducer
 */

const teamState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.UPDATE_TEAMS:
      return Object.assign({}, state, {
        teams: action.teams,
      });
    default:
      return state;
  }
};

export default teamState;
